import { Step } from '../models/step.model';
import { Pages } from '../enums/pages-enum';
import { SectionData } from '../models/section-data.model';
import { IconType } from '../enums/icon-type-enum';


const worklowData: Array<Step> =
[
    {
        Id: Pages.LOGIN,
        title: 'Identificación de cliente',
        url: '/home/login',
        icon: 'person',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.SECURITY_QUESTIONS_1,
        title: 'Datos de Seguridad',
        url: '/home/security-1',
        icon: 'help',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.SECURITY_QUESTIONS_2,
        title: 'Datos de Seguridad',
        url: '/home/security-2',
        icon: 'help',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.CONTACTS,
        title: 'Contacto',
        url: '/home/contacts',
        icon: 'phone',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.ORIGIN_MAP,
        title: 'Ubicación del vehículo',
        url: '/home/map',
        icon: 'location_on',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.ORIGIN_MAP_VALIDATION,
        title: 'Validacion de los datos',
        url: '/home/origin-map-validation',
        icon: 'location_on',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.ISSUE_DETAILS,
        title: 'Detalle del servicio',
        url: '/home/issue-details',
        icon: 'format_list_bulleted',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.TIRES,
        title: 'Neumáticos',
        url: '/home/tiers',
        icon: 'neumatico_icon.svg',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.CustomFile
    },
    {
        Id: Pages.DESTINATION_MAP,
        title: 'Destino del vehículo',
        url: '/home/map',
        icon: 'location_on',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.DESTINATION_MAP_VALIDATION,
        title: 'Validacion de los datos',
        url: '/home/origin-map-validation',
        icon: 'location_on',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.SERVICE_DETAILS,
        title: 'Información del traslado',
        url: '/home/svc-details',
        icon: 'help',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.DIMENSION_PICKUP,
        title: 'Dimensiones - PICK UP',
        url: '/home/dimension-pickup',
        icon: 'commute',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.DIMENSION_VEHICLE,
        title: 'Dimensiones - Utilitario',
        url: '/home/dimension-vehicle',
        icon: 'commute',
        sectionData: new SectionData(),
        active: false,
        iconType: IconType.Material
    },
    {
        Id: Pages.SUMMARY,
        title: 'Resumen del servicio',
        url: '/home/summary',
        icon: 'description',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.SERVICE_SUCCESS,
        title: 'Resumen del Servicio',
        url: '/home/service-success',
        icon: 'description',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    },
    {
        Id: Pages.TAKEN_SERVICE,
        title: 'Servicio solicitado',
        url: '/home/taken-service',
        icon: 'done_all',
        sectionData: new SectionData(),
        active: true,
        iconType: IconType.Material
    }
];

export { worklowData };
